import { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import Circle from '@/components/UI/svg/SaveElectric/Circle';
import AirConditioner from '@/components/UI/svg/SaveElectric/AirConditioner';
import Refrigerator from '@/components/UI/svg/SaveElectric/Refrigerator';
import Monitor from '@/components/UI/svg/SaveElectric/Monitor';
import Light from '@/components/UI/svg/SaveElectric/Light';
import Washing from '@/components/UI/svg/SaveElectric/Washing';

export default function D() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('save_electric');
    const [active, setActive] = useState(0);
    const [offset, setOffset] = useState(-960);

    const innerLine: any = {
        0: {
            width: 383,
            left: 0,
        },
        1: {
            width: 383,
            right: 0,
        },
    };

    const senceList = [
        {
            icon: <AirConditioner />,
            name: t('sec_5_tab1_sence1_title'),
            desc: t('sec_5_tab1_sence1_desc'),
        },
        {
            icon: <Refrigerator />,
            name: t('sec_5_tab1_sence2_title'),
            desc: t('sec_5_tab1_sence2_desc'),
            link: 'https://blog.ecoflow.com/jp/refrigerator-electric-bills/',
        },
        {
            icon: <Monitor />,
            name: t('sec_5_tab1_sence3_title'),
            desc: t('sec_5_tab1_sence3_desc'),
        },
        {
            icon: <Light />,
            name: t('sec_5_tab1_sence4_title'),
            desc: t('sec_5_tab1_sence4_desc'),
        },
        {
            icon: <Washing />,
            name: t('sec_5_tab1_sence5_title'),
            desc: t('sec_5_tab1_sence5_desc'),
        },
    ];

    const sence2List = [
        {
            icon: <Light />,
            name: t('sec_5_tab2_sence1_title'),
            desc: t('sec_5_tab2_sence1_desc'),
        },
        {
            icon: <AirConditioner />,
            name: t('sec_5_tab2_sence2_title'),
            desc: t('sec_5_tab2_sence2_desc'),
        },
        {
            icon: <Washing />,
            name: t('sec_5_tab2_sence3_title'),
            desc: t('sec_5_tab2_sence3_desc'),
        },
        {
            icon: <Monitor />,
            name: t('sec_5_tab2_sence4_title'),
            desc: t('sec_5_tab2_sence4_desc'),
        },
    ];

    useEffect(() => {
        setOffset(window.screen.width < 1600 ? -650 : -960);
    }, []);

    return (
        <div className={`save-electric-d ${css.SaveElectricD}`}>
            <div className="text-wrapper">
                <h3 className="sub-title">{t('sec_5_subtitle')}</h3>
                <p className="title">{t('sec_5_title')}</p>
            </div>
            <div className="tab">
                <div className="line">
                    <div className="inner-line" style={innerLine[active]}></div>
                </div>
                <div className="text">
                    <p className={active === 0 ? 'active' : ''} onClick={() => setActive(0)}>
                        {t('sec_5_tab1')}
                    </p>
                    <p className={active === 1 ? 'active' : ''} onClick={() => setActive(1)}>
                        {t('sec_5_tab2')}
                    </p>
                </div>
            </div>
            <section className={`section-a tab-content ${active === 0 ? 'show' : ''}`}>
                <p className="text">{t('sec_5_tab1_text')}</p>
                <div className="solution">
                    <div className="icon">
                        <Circle />
                    </div>
                    <div className="right">
                        <p className="title">{t('sec_5_tab1_title1')}</p>
                        <p className="desc">{t('sec_5_tab1_desc1')}</p>
                    </div>
                </div>
                <div className="solution">
                    <div className="icon">
                        <Circle num={2} />
                    </div>
                    <div className="right">
                        <p className="title">{t('sec_5_tab1_title2')}</p>
                        <p className="desc">{t('sec_5_tab1_desc2')}</p>
                    </div>
                </div>
                <Swiper className="sence-wrapper" initialSlide={0} lazy={true} spaceBetween={30} width={300} slidesOffsetAfter={offset}>
                    {senceList.map((item, index) => (
                        <SwiperSlide key={index} className="sence">
                            {item.icon}
                            {item.link ? (
                                <Link
                                    className="name link"
                                    href={item.link}
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'select_news',
                                        title_name: t('sec_5_title'),
                                        button_name: item.name,
                                    }}
                                >
                                    {item.name}
                                </Link>
                            ) : (
                                <p className="name">{item.name}</p>
                            )}
                            <p className="desc">{item.desc}</p>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>

            <section className={`section-b tab-content ${active === 1 ? 'show' : ''}`}>
                <p className="text">{t('sec_5_tab2_text')}</p>
                <div className="sence-wrapper">
                    {sence2List.map((item, index) => (
                        <div className="sence solution" key={index}>
                            <div className="icon">{item.icon}</div>
                            <div className="right">
                                <p className="title">{item.name}</p>
                                <p className="desc">{item.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
